<template>
  <!--<div id="app" style="min-height: 100%;">-->
  <div id="app">
    <!--------------------------header----------------------->
    <div style="display: flex;flex-direction: row" v-if="showHeader">
      <el-menu ref="header" class="el-menu-demo app-header" mode="horizontal" router :default-active="computedActive"
      :style="{width: headerWidth + 'px'}">
        <el-menu-item index="0" disabled style="opacity: 1;"><img src="static/img/gc-logo.png" style="width: 180px;"></el-menu-item>
        <el-menu-item :route="item.path" v-for="(item, idx) in headerList" :key="idx" :index="item.path" style="font-size: 1.1rem;font-weight: 500">{{item.name}}</el-menu-item>
        <!--<el-menu-item @click="onClickMKT" :key="1000" :index="emktList.path" style="font-size: 1.1rem;font-weight: 500">{{emktList.name}}</el-menu-item>-->
      </el-menu>
      <ul class="ul-user" v-if="customerInfo && customerInfo !== null && customerInfo.customerName">
          <li class="li-user" slot="reference" v-if="customerInfo">
            <el-dropdown trigger="click">
              <span style="color: #409eff;">您好：{{customerInfo.customerName}}<i class="el-icon-arrow-down el-icon--right"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><el-button class="btn-tag list-btn" type="text" @click="checkCustomerInfo" icon="el-icon-info el-icon--left" style="margin-left: 0;"> 个人资料</el-button></el-dropdown-item>
                <!--<el-dropdown-item divided> <i class="el-icon-info el-icon&#45;&#45;left"><span @click="checkContractInfo"> 合同信息</span> </i></el-dropdown-item>-->
                <!--<el-dropdown-item divided> <i class="el-icon-tickets el-icon&#45;&#45;left"><span @click="checkDownloadInfo"> 下载历史</span> </i></el-dropdown-item>-->
                <el-dropdown-item divided><el-button class="btn-tag list-btn" type="text" @click="changePassword" icon="el-icon-edit el-icon&#45;&#45;left" style="margin-left: 0;"> 修改密码</el-button></el-dropdown-item>
                <!--<el-dropdown-item divided> <i class="el-icon-info el-icon&#45;&#45;left"> 上传历史</i></el-dropdown-item>-->
                <!--<el-dropdown-item divided> <i class="el-icon-info el-icon&#45;&#45;left"><span @click="logout"> 帮助中心</span> </i></el-dropdown-item>-->
                <el-dropdown-item divided> <el-button class="btn-tag list-btn" type="text" @click="logout" icon="el-icon-cus-log-out el-icon--left" style="margin-left: 0;">退出登录</el-button></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        <!--<li class="li-user li-line" @click="clickNotification">-->
          <!--<el-badge :value="12" class="item">-->
            <!--通知-->
          <!--</el-badge></li>-->
        <!--<li class="li-user" @click="clickLeaveMsg">留言</li>-->
      </ul>
      <ul class="ul-user" v-else>
        <li style="width: 70%;"><el-button class="li-user" type="text" @click="goToLogin">登录</el-button></li>
        <!--<li><el-button class="li-user li-line" type="text" @click="goToLogin" style="border-right: 1px solid #dcdcdc;padding-top: 0;padding-right: 10px;">登录</el-button></li>-->
        <!--<li><el-button class="li-user" type="text" @click="goToRegister" style="padding-top: 0;padding-left: 10px;">注册</el-button></li>-->
      </ul>
    </div>
    <!--------------------------header----------------------->
    <div style="display: flex;flex-direction: row">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
      <router-view v-if="$route.name==='netDisk'" name="all"></router-view>
    </div>
    <!--<notification :dialogVisible="NotiDialogVisible"      @closeDialog="closeNotificationDialog"></notification>-->
    <!--<leave-msg :dialogVisible="LeaveMsgDialogVisible"     @closeDialog="closeLeaveMsgDialog"></leave-msg>-->
    <change-pass :dialogVisible="ChangePassDialogVisible" @closeDialog="closeChangePassDialog"></change-pass>
    <!--<contract-info :dialogVisible="ConInfoDialogVisible"  @closeDialog="closeConInfoDialog"></contract-info>-->
    <customer-info :dialogVisible="CusInfoDialogVisible"  @closeDialog="closeCusInfoDialog"></customer-info>
    <help :dialogVisible="HelpDialogVisible"              @closeDialog="closeHelpDialog"></help>
    <download-info :dialogVisible="DownInfoDialogVisible" @closeDialog="closeDownInfoDialog"></download-info>
    <login-dialog :dialogVisible="showLoginDialog" @closeLoginDialog="closeLoginDialog"></login-dialog>
  </div>
</template>

<script>
import ct from './utils/constant.js'
import { mapMutations, mapState, mapGetters } from 'vuex'
import Notification from './pages/secPages/Notification.vue'
import LeaveMsg from './pages/secPages/LeaveMsg.vue'
import ChangePass from './pages/user/ChangePassword.vue'
import ContractInfo from './pages/user/ContractInfo.vue'
import CustomerInfo from './pages/user/UserInfo.vue'
import Help from './pages/user/Help.vue'
import DownloadInfo from './pages/user/DownloadInfo.vue'
import LoginDialog from './components/dialog/LoginDialog.vue'
// import { getStorage } from './utils/utils.js'
export default {
  name: 'App',
  created () {
  },
  mounted () {
    window.addEventListener('resize', this.screenSizeHandler)
  },
  data () {
    return {
      headerWidth: window.innerWidth - 150,
      NotiDialogVisible: false,
      LeaveMsgDialogVisible: false,
      ChangePassDialogVisible: false,
      ConInfoDialogVisible: false,
      CusInfoDialogVisible: false,
      HelpDialogVisible: false,
      DownInfoDialogVisible: false,
      select: null,
      headerList: [
        {id: 1, name: ct.RouterData.netDisk.label, path: ct.RouterData.netDisk.path}
        // {id: 3, name: ct.RouterData.emkt.label, path: ct.RouterData.emkt.path}
        // {id: 2, name: ct.RouterData.daiDing.label, path: ct.RouterData.daiDing.path},
      ],
      emktList: {id: 3, name: ct.RouterData.emkt.label, path: ct.RouterData.emkt.path},
      isShowLoginBar: false,
      showLoginDialog: false
    }
  },
  components: {
    Notification,
    LeaveMsg,
    ChangePass,
    ContractInfo,
    CustomerInfo,
    Help,
    DownloadInfo,
    LoginDialog
  },
  watch: {
  },
  methods: {
    ...mapMutations(['setToolBarLeft', 'setComputedWidth', 'setComputedHeight', 'setComputedTop', 'setFilesList', 'setTagsList', 'setShowProgress', 'initCustomerInfo']),
    screenSizeHandler () {
      this.setToolBarLeft(window.innerWidth - 643)
      this.setComputedWidth(window.innerWidth - 210)
      this.setComputedHeight(window.innerHeight - 69)
      this.headerWidth = window.innerWidth - 150
    },
    clickNotification () {
      this.NotiDialogVisible = true
    },
    clickLeaveMsg () {
      this.LeaveMsgDialogVisible = true
    },
    logout () {
      this.getRequest('gcwwwifc/userLogout').then(response => {
        window.localStorage.clear()
        window.sessionStorage.clear()
        this.clearCookie()
        this.$router.push(ct.RouterData.login.path)
        this.setShowProgress(false)
        this.initCustomerInfo(null)
      })
    },
    clearCookie () {
      let keys = document.cookie.match(/[^ =;]+(?=)/g)
      if (keys) {
        for (let i = keys.length; i--;) {
          document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
        }
      }
    },
    checkCustomerInfo () {
      this.CusInfoDialogVisible = true
    },
    checkContractInfo () {
      this.ConInfoDialogVisible = true
    },
    checkDownloadInfo () {
      this.DownInfoDialogVisible = true
    },
    changePassword () {
      this.ChangePassDialogVisible = true
    },
    closeNotificationDialog () {
      this.NotiDialogVisible = false
    },
    closeLeaveMsgDialog () {
      this.LeaveMsgDialogVisible = false
    },
    closeChangePassDialog () {
      this.ChangePassDialogVisible = false
    },
    closeConInfoDialog () {
      this.ConInfoDialogVisible = false
    },
    closeCusInfoDialog () {
      this.CusInfoDialogVisible = false
    },
    closeHelpDialog () {
      this.HelpDialogVisible = false
    },
    closeDownInfoDialog () {
      this.DownInfoDialogVisible = false
    },
    onClickMKT () {
      window.open('http://gmall.taogene.com/desktop_index.html?desktop=1')
    },
    goToLogin () {
      // this.showLoginDialog = true
      this.$router.push(ct.RouterData.login.path)
    },
    goToRegister () {
      this.$router.push(ct.RouterData.register.path)
    },
    closeLoginDialog () {
      this.showLoginDialog = false
    }
  },
  computed: {
    ...mapState(['computedHeight', 'computedWidth', 'customerInfo', 'user']),
    ...mapGetters(['getIsLogin']),
    titleColor () {
      if (this.$route.name.indexOf('File') > -1) {
        return '#409EFF'
      }
    },
    computedActive () {
      console.log('computedActive')
      if (this.$route.name !== null) {
        if (this.$route.path.indexOf('netDisk') > -1) {
          return ct.RouterData.netDisk.path
        }
      }
      return this.$route.path
    },
    showHeader () {
      let name = this.$route.name
      let r = ct.RouterData
      return name !== r.login.name && name !== r.register.name && name !== r.forgetPass.name
    }
  }
}
</script>

<style>
.ul-user {
  height: 40px;
  top: 20px;
  width: 150px;
  border-right: none;
  border-bottom: solid 1px #e6e6e6;
  list-style: none;
  position: relative;
  margin: 0;
  padding-left: 0;
  display: flex;
  flex-direction: row;
}

.li-user {
  border-bottom-color: transparent;
  float: right;
  opacity: 1;
  height: 18px;
  line-height: 18px;
  margin: 0;
  border-bottom: 2px solid transparent;
  /*color: #303133;*/
  padding: 0 11px;
  font-size: 14px;
  font-weight: 800;
  display: flex;
  flex-direction: row;
}

.el-popover .el-popper {
  min-width: 100px;
}

.li-font {
  font-size: 14px;
  font-weight: 800;
}

.li-line {
  border-right: solid 1px gainsboro;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.custom-tree-container {
  width: 70%;
  /*margin:auto;*/
}

.lookup {
  color: #409EFF;
  text-decoration: none;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.line {
  border-width: 0.5px;
  border-style: solid;
  border-color: gainsboro;
  margin: 0;
}

.el-select {
  width: 100%
}

.app-content {
  left: 210px;
  position: absolute;
  width: 90%;
  min-width: 700px;
}

.app-navigation {
  position: absolute;
  width: 200px;
}

.app-header {
}

.btn-operate .el-button--mini, .el-button--mini.is-round {
  padding:0;
  font-size: 17px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}

.el-dialog__header .el-dialog__title {
  font-size: 14px;
}

#select .el-select .el-input {
  width:300px;
}

.register-header {
  position: absolute;
  height: 60px;
  width: 100%;
  left: 0;
  z-index: 3;
  background-color: white;
  display: flex;
  flex-direction: row;
}

.register-container {
  height: 570px;
  width: 100%;
  /*margin-top: 60px;*/
  display: flex;
  justify-content: center;
  align-items: center;
  /*margin-left:40%;*/
  position: absolute;
}

.register-foot {
  height: 180px;
  background-color: white;
  position: absolute;
  /* margin-top: 660px; */
  z-index: 4;
  opacity: 0.9;
  /*margin-bottom: 20px;*/
  text-align: center;
  bottom: 20px;
  width: 100%;
}

.con-box {
  background-color: white;
  width: 400px;
  /*height: 480px;*/
  border-radius: 5px;
  /*float: right;*/
  z-index: 3;
  /*margin: 70px 200px 80px 80px;*/
  border: solid 1px gainsboro;
  opacity: 0.9;
}

.demo-ruleForm {
  padding: 30px 50px;
}

.ibg-bg {
  /*position:fixed;*/
  position: absolute;
  top: 60px;
  left: 0;
  width:100%;
  height: 780px;
  min-width: 1100px;
  z-index:-10;
  zoom: 1;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  -webkit-transition: background 1s;
  -moz-transition: background 1s;
  -o-transition: background 1s;
  transition: background 1s;
  /*background: url(/static/img/banner1.jpg) no-repeat center center;*/
  /*background-image: url(static/img/banner2.jpg);*/
}

  .submit-btn {
    margin-bottom:0;
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .row {
    display: flex;
    flex-direction: row;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue